import React from 'react'
import './Instructions.css'
import { useApp } from '../../AppContext/AppContext'

const Instructions = () => {
  const { selectedApp, currentColor } = useApp()

  // Define the image sources for each app
  const appImages = {
    Instagram: ['1.svg', '2.svg', '3.svg', '4.svg'],
    Facebook: ['5.svg', '6.svg', '7.png', '8.svg'],
    Tiktok: ['29.svg', '30.svg', '31.svg', '32.svg'],
    
    Dailymotion: ['13.svg', '14.svg', '15.svg', '16.svg'],
    'X-twitter':  ['9.svg', '10.svg', '11.svg', '12.svg'],
    IMDb:['17.svg', '18.svg', '19.svg', '20.svg'],
    Likee: ['21.svg', '22.svg', '23.svg', '24.svg'],
    Bitchute: ['25.svg', '26.svg', '27.svg', '28.svg'],
    Thread: ['33.svg', '34.svg', '35.svg', '36.svg'],
    Veoh: ['37.svg', '38.svg', '39.svg', '40.svg'],
    BuzzVideo: ['41.svg', '42.svg', '43.svg', '44.svg'],
    ESPN: ['69.svg', '70.svg', '71.svg', '72.svg'] ,
    ifunny:['65.svg', '66.svg', '67.svg', '68.svg'] ,
    imgur:  ['45.svg', '46.svg', '47.svg', '48.svg'],
    LinkedIn: ['49.svg', '50.svg', '51.svg', '52.svg'],
    Reddit:  ['53.svg', '54.svg', '55.svg', '56.svg'],
    Pinterest: ['57.svg', '58.svg', '59.svg', '60.svg'],
    Snapchat:  ['61.svg', '62.svg', '63.svg', '64.svg'],
    Flikr: ['73.svg', '74.svg', '75.svg', '76.svg'],
    'All Video Downloader': ['77.svg', '78.svg', '79.svg', '80.svg'],
    
  }

  // Get the images for the selected app, or default to 'All Video Downloader'
  const images = appImages[selectedApp] || appImages['All Video Downloader']

  return (
    <>
    <div className='instructions-container'>
        <div className='instructions-title'>
            <h1 className='instructions' >Generic</h1>
            <h1 className='generic' style={{ color: currentColor }}>Instructions</h1>
        </div>
        <div className='instuctin-para'>
            <p className='inst-para'>Follow These Easy Steps to Download and Keep Videos</p>
        </div>
        <div className='instructions-content'>
            {images.map((image, index) => (
                <img className='ins-img' key={index} src={`./assets/${image}`} alt={`Instruction ${index + 1}`} />
            ))}
        </div>
    </div>
    </>
  )
}

export default Instructions